import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {resolveApiBase} from '../../core/api-base';

export interface DeviceLookupResponse {
  app_name: string;
  scopes: string[];
}

export interface DeviceResultResponse {
  result: 'approved' | 'denied';
}

// DeviceService — the RFC 8628 second-screen approval API (Story 32.4). Both
// calls are keyed on the human user_code (never the device_code). Story 53.9:
// the user is authenticated by the host-only session cookie the browser
// attaches to these same-origin calls — no session in the URL or body.
// resolveApiBase() keeps the SPA same-origin when deployed and targets the
// remote API under karma. (deny() had no caller and went with 53.9.)
@Injectable({providedIn: 'root'})
export class DeviceService {
  private readonly http = inject(HttpClient);

  lookup(userCode: string): Observable<DeviceLookupResponse> {
    return this.http.get<DeviceLookupResponse>(
      `${resolveApiBase()}/device/lookup`,
      {params: {user_code: userCode}}
    );
  }

  approve(userCode: string): Observable<DeviceResultResponse> {
    return this.http.post<DeviceResultResponse>(
      `${resolveApiBase()}/device/approve`,
      {user_code: userCode}
    );
  }
}
